export const formatChartValue = (value, percentage = false) => {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return percentage ? '0,0%' : 'N 0'
  if (percentage)
    return `${numeric.toLocaleString('pt-BR', {
      minimumFractionDigits: numeric % 1 ? 1 : 0,
      maximumFractionDigits: 1,
    })}%`
  return `N ${numeric.toLocaleString('pt-BR', {
    maximumFractionDigits: 1,
  })}`
}
